app.directive('signupSocial', [function () {
    return {
        templateUrl: 'templates/directives/signupSocial.html'
    }
}]);
